import Experience from '../Experience.js'
import Environment from './Environment.js'
import Floor from './Floor.js'
import WorkTable from './WorkTable.js'
import WorkTableConfigurator from './WorkTableConfigurator.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        // Wait for resources
        this.resources.on('ready', () =>
        {
            this.floor = new Floor()
            this.workTable = new WorkTable()
            this.workTableConfigurator = new WorkTableConfigurator(this.workTable)
            this.environment = new Environment()
        })
    }

    update()
    {

    }
}
